import React, { Component } from 'react';
import * as Common from '../helpers/Common';
const $=window.$;

class Addmore extends Component {

constructor(props) {
        super(props);
        this.state={
            more_fields:[{deleteoption: false}]

        };


    }

    componentWillReceiveProps(nextProps) {

         // if(nextProps.newstate!=undefined){
         //   nextProps.newstate.map((key,index)=>{

         //    this.state.more_fields.push({deleteoption: key.deleteoption});
         //  }
         // )


         // }

         if(nextProps.editType!=undefined){
            if(nextProps.editType == 'edit' && nextProps.compType=='parent'){
                this.setState({
                    more_fields : [{deleteoption: true}]
                })
            }
         }

    }

addRow(){

    const {limit,selector,refreshScroll,compType,parent,editType,startId}=this.props;


  if(editType == 'edit' && compType=='parent'){
        // $("#"+selector+startId);
        let div_id = $('div[id^="'+selector+'"]').last().attr('id');
        $("#"+div_id).css('display','block');
        $('#'+div_id+ ' :input').removeAttr('disabled');
        //alert($('div[id^="'+selector+'"]').length);
       if(limit>$('div[id^="'+selector+'"]').length){
        const more_fields = [...this.state.more_fields,{deleteoption: true}];
        this.setState({
         more_fields
        });

        if(refreshScroll!=undefined){

         refreshScroll('add_'+selector);

        }

       }else{

        Common.message('Oops!!','You can add only '+limit+' Question(s).','error');

       }
  }

  else if(compType=='parent' && editType=="form"){
    if(limit>$('div[id^="'+selector+'"]').length){
        const more_fields = [...this.state.more_fields,{deleteoption: true}];
        this.setState({
         more_fields
        });

        if(refreshScroll!=undefined){

         refreshScroll('add_'+selector);

        }

       }else{

        Common.message('Oops!!','You can add only '+limit+' '+selector+'(s).','error');

       }
  }
  if(editType == 'edit' && compType=='child'){

        let parentid = "";
        if(this.refs.node.parentNode != ""){
          parentid = this.refs.node.parentNode.id;
        }

       //  alert(selector);

            let div_id = $("#"+parent+"_"+parentid+" div[id^='"+selector+"']").last().attr('id');
            //alert(div_id);
            $("#"+parent+"_"+parentid+" #"+div_id+' :input').removeAttr('disabled');
            $("#"+parent+"_"+parentid+" #"+div_id).css('display','block');

            // $("#"+parent+"_"+parentid+" #"+div_id +' :input').attr('disabled',false);

          //ddd  alert($("#"+parent+"_"+parentid+" div[id^='"+selector+"']").length);

          if(limit>$("#"+parent+"_"+parentid+" div[id^='"+selector+"']").length){

             const more_fields = [...this.state.more_fields,{deleteoption: true}];
             this.setState({
              more_fields
             });

             if(refreshScroll!=undefined){

              refreshScroll('add_'+selector);

             }

          }else{

             Common.message('Oops!!','You can add only '+limit+' Answer(s).','error');

          }
          
  }
  else if(compType=='child' && editType=="form"){

   // alert('here');

        let parentid = "";
        if(this.refs.node.parentNode != ""){
          parentid = this.refs.node.parentNode.id;
        }


          if(limit>$("#"+parent+"_"+parentid+" div[id^='"+selector+"']").length){

             const more_fields = [...this.state.more_fields,{deleteoption: true}];
             this.setState({
              more_fields
             });

             if(refreshScroll!=undefined){

              refreshScroll('add_'+selector);

             }

          }else{

             Common.message('Oops!!','You can add only '+limit+' '+selector+'(s).','error');

          }
    }


    }

    deleteRow(index){
        //alert(index);
      const {selector,refreshScroll,parent,compType}=this.props;
      //alert(selector);
      if(compType == 'parent'){

        if($('div#'+selector+'_'+index).length>0){
          
          $('div#'+selector+'_'+index).remove();
        }


          if(refreshScroll!=undefined){

             refreshScroll('remove_'+selector);

          }
        
      }

      if(compType == 'child'){
        let parentid = "";
        if(this.refs.node.parentNode != ""){
          parentid = this.refs.node.parentNode.id;
        }
       // alert(parentid);
        //alert("#"+parent+"_"+parentid+" div#"+selector+"_"+index);
        if($("#"+parent+"_"+parentid+" div#"+selector+"_"+index).length>0){

         $("#"+parent+"_"+parentid+" div#"+selector+"_"+index).remove();
        }
          if(refreshScroll!=undefined){

             refreshScroll('remove_'+selector);

          }
      }


    }

    // setAdmoreFields(data){
    //
    //
    //     if (data.length>0) {
    //         $('#imageloader').show();
    //
    //             var moreFieldsValue=[];
    //
    //               for(var J=0;J<data.length;J++){
    //
    //                 if(J==0){
    //                   moreFieldsValue.push({deleteoption: false});
    //
    //                 }else{
    //                   moreFieldsValue.push({deleteoption: true});
    //                 }
    //
    //               }
    //
    //             $('#imageloader').hide();
    //
    //         }
    //
    //     this.setState({
    //         more_fields:moreFieldsValue
    //     });
    // }
    componentDidMount() {
        const {editType,subType,compType,polls_sent} = this.props;
        if(editType == 'edit' && subType=='subtype' && compType=='child' && polls_sent!=""){
            this.setState({
                more_fields : [{deleteoption: true}]
            })
        }
        
    }




    render() {

       // alert(JSON.stringify(this.state.more_fields));

        const {selector,onChange,AddLabel,DeleteLabel,compType,editType,startId,polls_sent,subType}=this.props;
     let more_fields=null;




     

     //alert(JSON.stringify(this.state.more_fields));
     if(editType == 'edit' && compType=='parent'){
        let id_sent = startId+1;
        // alert(startId);
        //alert(id_sent);
        more_fields=this.state.more_fields.map((key,inde)=>{
            let id_show = id_sent;
            id_sent++;
            return(<div key={`pac_${id_sent}`}><div  id={`${selector}_${id_show}`} style={{display:'none'}}>
             {(key.deleteoption==true)?
              <a className={`btn-red pull-right remove_${selector}`} onClick={(e)=>this.deleteRow(id_show) }>{DeleteLabel}</a>:''
             }
             {this.props.children}
             <div className="clear"></div>
             </div></div>)
         });
       
     }
     else if(compType=='parent' && editType=="form"){
     
         more_fields=this.state.more_fields.map((key,inde)=>

         <div key={`parentco_${inde}`} id={`${selector}_${inde}`}>
         {(key.deleteoption==true)?
          <a className={`btn-red pull-right remove_${selector}`} onClick={e=>this.deleteRow(inde) }>{DeleteLabel}</a>:''
         }
         {this.props.children}
         <div className="clear"></div>
         </div>

        );
     }

    if(editType == 'edit' && compType=='child' && subType=='subtype' && polls_sent != ""){
       //alert(selector);
        let id_sent = startId;
        more_fields=this.state.more_fields.map((key,inde)=>{
            id_sent++;
            let id_show = id_sent;

            return(<div key={`chc_${id_sent}`}><div  id={`${selector}_${id_show}`} className="child_inputs" style={{display:'none'}}>
             {(key.deleteoption==true)?
              <a className={`btn-red pull-right remove_${selector}`} onClick={(e)=>this.deleteRow(id_show) }>{DeleteLabel}</a>:''
             }
             {this.props.children}
             <div className="clear"></div>
             </div></div>)
         });
          
     }
    else if(compType=='child' && polls_sent == "" || polls_sent==undefined){
       // alert('im here');
         more_fields=this.state.more_fields.map((key,inde)=>

         <div key={`childco_${inde}`} id={`${selector}_${inde}`} className="child_inputs" >
         {(key.deleteoption==true)?
          <a className={`btn-red pull-right remove_${selector}`} onClick={e=>this.deleteRow(inde) }>{DeleteLabel}</a>:''
         }
         {this.props.children}
         <div className="clear"></div>
         </div>

        );
     }






        return (
            <div ref="node">
            {(polls_sent)?polls_sent:''}

            {more_fields}

             <a className={`btn-green pull-right add_${selector}`} onClick={(e) => this.addRow() }>{AddLabel}</a>
            </div>

        );
    }
}

export default Addmore;


// WEBPACK FOOTER //
// ./src/components/Addmore.js